export const defaultRecentStartDateMonthSubstract = 12;
